export const classes = {
  wrapper: 'flex flex-col items-center',
};

export const PRESS_RELEASES = [
  {
    name: 'Condor+Technologies+NV+21+sept+2026',
    href: 'https://condor-investors-content.s3.eu-central-1.amazonaws.com/press_releases/Condor+Technologies+NV+21+sept+2026.pdf',
  },
  {
    name: 'Condor+Technologies+NV+31+aug+2026',
    href: 'https://condor-investors-content.s3.eu-central-1.amazonaws.com/press_releases/Condor+Technologies+NV+31+aug+2026.docx',
  },
  {
    name: 'Publicatie+Oproepingsbrief_De+Tijd_22.08.2025.pdf',
    href: 'https://condor-investors-content.s3.eu-central-1.amazonaws.com/press_releases/Publicatie%2BOproepingsbrief_De%2BTijd_22.08.2025.pdf',
  },
  {
    name: 'Condor Technologies Announces Breakthrough in Dental Scanning Technology and Exploring Strategic Partnerships',
    href: 'https://condor-investors-content.s3.eu-central-1.amazonaws.com/press_releases/condor-technologies-announces-breakthrough-in-dental-scanning-technology-and-exploring-strategic-partnerships-pdf.pdf',
  },
  {
    name: 'Communiqué CondorTech - finaal - PDF_02777527.PDF',
    href: 'https://condor-investors-content.s3.eu-central-1.amazonaws.com/press_releases/Communique%CC%81+CondorTech+-+finaal+-+PDF_02777527.PDF',
  },
  {
    name: 'Oproepingsbrief+AV_+2_06_2020_02628683.pdf',
    href: 'https://condor-investors-content.s3.eu-central-1.amazonaws.com/shareholders_meeting/Oproepingsbrief+AV_+2_06_2020_02628683.pdf',
  },
  {
    name: 'Condor Technologies NV and Financière WOW sign a sale and purchase agreement for 70% of the shares of Condor SAS',
    href: 'https://condor-investors-content.s3.eu-central-1.amazonaws.com/press_releases/Communique%CC%81+Condor+Technologies+NV+EN+-+Clean+version+-+PDF_02561617.PDF',
  },
  {
    name: 'EURONEXT TRADING SUSPENSION - Condor Technologies NV (ISIN BE6252013725)',
    href: 'https://s3.eu-central-1.amazonaws.com/condor-investors-content/press_releases/EURONEXT%20TRADING%20SUSPENSION%20-%20Condor%20Technologies%20NV%20%28ISIN%20BE6252013725%29.pdf',
  },
  {
    name: 'Condor_Technologies_NV_Oproepingsbrief_AV_4-06-2019_en_BAV_18-06-2019_en_BAV_25-06-2019.pdf',
    href: 'https://s3.eu-central-1.amazonaws.com/condor-investors-content/press_releases/Condor_Technologies_NV_Oproepingsbrief_AV_4-06-2019_en_BAV_18-06-2019_en_BAV_25-06-2019.pdf',
  },
  {
    name: 'Publicatie+Oproepingsbrief+Condor+Technologies+NV_AV+5+juni+2018_De+Tijd.pdf',
    href: 'https://s3.eu-central-1.amazonaws.com/condor-investors-content/press_releases/Publicatie+Oproepingsbrief+Condor+Technologies+NV_AV+5+juni+2018_De+Tijd.pdf',
  },
  {
    name: 'Publicatie+Oproepingsbrief_De+Tijd_13.02.2018.pdf',
    href: 'https://s3.eu-central-1.amazonaws.com/condor-investors-content/press_releases/Publicatie+Oproepingsbrief_De+Tijd_13.02.2018.pdf',
  },
  {
    name: 'De+Tijd_Tandarts+scant+uw+mond+met+ruimtevaarttechnologies_20+oktober+2016.pdf',
    href: 'https://s3.eu-central-1.amazonaws.com/condor-investors-content/press_releases/De+Tijd_Tandarts+scant+uw+mond+met+ruimtevaarttechnologies_20+oktober+2016.pdf',
  },
];
